export var defaultSocialsProviders = ['apple', 'facebook', 'google'
//'openpass',
];